import { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import manifest from "../../content/generated/route-manifest.json";
import type { ContentRouteEntry } from "../../domain/content-schema";
import { Icon } from "../../design-system/primitives/Icon";
import { repairLegacyEncoding } from "../../platform/content/repairLegacyEncoding";
import styles from "./GlobalSearchPanel.module.css";

const routes = (manifest as ContentRouteEntry[]).filter((entry) => !["home", "search"].includes(entry.kind));

export function GlobalSearchPanel({ onClose, variant = "panel" }: { readonly onClose: () => void; readonly variant?: "panel" | "drawer" }) {
  const [query, setQuery] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => { inputRef.current?.focus(); }, []);

  const results = useMemo(() => {
    const normalized = query.trim().toLocaleLowerCase("tr-TR");
    const source = normalized ? routes.filter((entry) => repairLegacyEncoding(entry.title).toLocaleLowerCase("tr-TR").includes(normalized)) : routes;
    return source.slice(0, 8);
  }, [query]);

  const isDrawer = variant === "drawer";

  return <section id={isDrawer ? "drawer-search" : "global-search-panel"} className={`${styles.panel} ${isDrawer ? styles.drawer : ""}`} role="search" aria-label="PedEmUP içerik araması">
    <div className={styles.inner}>
      {!isDrawer && <div className={styles.heading}><div><p>PedEmUP arama</p><h2>İçeriğe doğrudan ulaşın</h2></div><button type="button" onClick={onClose} aria-label="Aramayı kapat"><Icon name="close" /></button></div>}
      <label className={styles.field}><Icon name="search" /><span className="sr-only">İçerik ara</span><input ref={inputRef} type="search" value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Olgu, klinik kart, ilaç veya rehber ara…" autoComplete="off" /></label>
      {(!isDrawer || query) && <div className={styles.resultHeading}><strong>{query ? `${results.length} sonuç` : "Hızlı erişim"}</strong><span>Başlıklar içinde aranır</span></div>}
      {(!isDrawer || query) && <div className={styles.results} aria-live="polite">
        {results.map((entry) => <Link key={entry.id} to={entry.path} onClick={onClose}><span>{categoryLabel(entry.category)}</span><strong>{repairLegacyEncoding(entry.title)}</strong><Icon name="arrow" /></Link>)}
        {!results.length && <p>Bu ifadeyle eşleşen içerik bulunamadı.</p>}
      </div>}
    </div>
  </section>;
}

function categoryLabel(category: ContentRouteEntry["category"]): string {
  const labels: Partial<Record<ContentRouteEntry["category"], string>> = {
    interactive_cases: "Vaka ile Öğren", clinical_cards: "Klinik Kart", drug_safety: "İlaç Güvenliği", diagnostic_error_atlas: "Hata Atlası", shift_companion: "Nöbet Dostu", guidelines: "Rehber", learning_modules: "Eğitim Modülü", evidence_radar: "Makale Radarı", journal_club: "Makale Kulübü", special_resuscitation: "Resüsitasyon",
  };
  return labels[category] ?? "PedEmUP";
}
